// Toggle Time Panel based on Suite Header variant
export function toggleTimePanel() {
    (window as any).O365Shell.FlexPane.OpenFlexPaneForProvider('OwaTimePanel');
}
